import React from "react";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import img1 from "../../images/Group.png";
import worldImage from "../../images/worldwide.PNG";
import Header from "../../components/layout/header";

import "../scss/pages/service.scss"; // SCSS file ka path adjust kar lena

// ✏️ Service Data Object (Sab services included)
const serviceData = {
  "air-freight": {
    title: "Air Freight",
    description: "Fast and secure air transport solutions worldwide.",
    buttons: [
      "Let's Do Business",
      "Service Levels",
      "Value Added Services",
      "Cleaner Airfreight",
      "Perishable Logistics",
    ],
    products: [
      {
        title: "General Cargo",
        image: "/fourteen.jpg", // Replace with actual URL
      },
      {
        title: "Special Cargo",
        image: "/fifth.jpg",
      },
      {
        title: "Live Animals Cargo",
        image: "/second.jpg",
      },
    ],
    images: ["/eleven.jpg", "/third.jpg", "/plane1.jpg"],

    headings: {
      main: "Smarter Airfreight Solutions",
      glance: "At a Glance",
    },

    glanceItems: [
      " Daily air cargo services with fast delivery across Worldwide",
      " Direct air shipments or consolidated options for safe, reliable transport",
      " Advanced digital systems (EDI)Electronic Data Interchange. and a skilled, dedicated team",
      "Real-time GPS and online tracking for full shipment visibility",
    ],

    contentParagraphs: [
      "Whether it's full charter or consolidated shipments, our smart technology and dedicated team help you move your goods by air quickly and smoothly. We offer fast delivery times, dependable space availability, flexible service options, and outstanding support tailored to your needs.",
      "Every day, our air cargo network ensures your shipments reach their destination efficiently and affordably. As part of strong global partnerships, we provide access to major airports worldwide. Plus, our experienced customs experts make sure your air freight clears smoothly and securely—helping your business grow across international borders.",
    ],
  },

  "sea-freight": {
    title: "Sea Freight",
    description: "Reliable and cost-effective ocean shipping solutions.",
    buttons: [
      "Let's Do Business",
      "Freight Rates",
      "Container Tracking",
      "Shipping Schedule",
    ],
    products: [
      {
        title: "Full Container Load (FCL)",
        image: "/fourteen.jpg", // Replace with actual URL
      },
      {
        title: "Less than Container Load (LCL)",
        image: "/plane1.jpg",
      },
      {
        title: "Integrated Supply Chain Solutions",
        image: "/0-0.jpg",
      },
    ],
    images: ["/sixth.jpg", "/seven.jpg", "/sea.jpg"],

    headings: {
      main: "More Efficiency on Seafreight",
      glance: "At a Glance",
    },

    glanceItems: [
      " Global LCL & FCL Shipping – Efficient groupage and full container services with reliable schedules",
      "Secure Door-to-Door Delivery – Hassle-free cargo transport with trusted handling",
      "Advanced Digital Solutions – Modern tracking systems (EDI) & expert logistics team",
      "Real-Time Shipment Updates – GPS-enabled monitoring for complete visibility",
    ],

    contentParagraphs: [
      "Whether you need full container loads (FCL) or Less than Container Load (LCL), we offer sea freight services designed around your needs. With the help of modern technology and a skilled team, we make sure your cargo moves quickly, safely, and smoothly. Enjoy faster delivery times, dependable space availability, a variety of shipping options, and service you can count on",
      "Every day, our trucks help your goods reach their destination efficiently and affordably. Being part of strong logistics networks, we can move your shipments across Pakistan and beyond. Plus, our experienced customs experts ensure smooth and secure clearance, supporting your business growth across borders.",
    ],
  },
  nvocc: {
    title: "NVOCC",
    description: "Reliable and cost-effective ocean shipping solutions.",
    buttons: [
      "Let's Do Business",
      "Freight Rates",
      "Container Tracking",
      "Shipping Schedule",
    ],
    products: [
      {
        title: "Full Container Load (FCL)",
        image: "/0-1.jpg", // Replace with actual URL
      },
      {
        title: "Less than Container Load (LCL)",
        image: "/0-0.jpg",
      },
      {
        title: "Integrated Supply Chain Solutions",
        image: "/nvocc-1.webp",
      },
    ],
    images: ["/nvocc-1.webp", "/seven.jpg", "/sea.jpg"],

    headings: {
      main: "Efficient NVOCC Services for Your Freight Needs",
      glance: "At a Glance",
    },

    glanceItems: [
      "Flexible Shipping Solutions – Full container loads (FCL) and groupage (LCL) options tailored to your needs",
      "Global Freight Network – Reliable space booking with trusted vessel operators for secure transport",
      "Advanced Technology – Modern IT systems (EDI) for seamless communication and efficient management",
      "Customs Clearance & Documentation – Experienced team ensuring hassle-free customs processing and paperwork",
    ],

    contentParagraphs: [
      "Whether it’s full container loads (FCL) or groupage services (LCL), our NVOCC services provide flexible and tailored solutions for all your shipping requirements. With the use of advanced technology and a dedicated team, we ensure fast, cost-effective, and reliable delivery times, giving you peace of mind with every shipment",
      "We manage every aspect of your road transport, from booking space with trusted carriers to offering secure and efficient delivery across Pakistan and beyond. As part of leading logistics networks, we ensure your shipments are handled smoothly, with full transparency and top-notch service quality. Our experienced staff also ensures all necessary documentation and customs clearance are done with the utmost care for hassle-free transport.",
    ],
  },
  "road-transport": {
    title: "Road Transport",
    description: "Safe and efficient road transport solutions.",
    buttons: [
      "Let's Do Business",
      "Delivery Tracking",
      "Heavy Haulage",
      "Temperature Controlled",
    ],
    products: [
      {
        title: "Origin Transport",
        image: "/1-1.jpg", // Replace with actual URL
      },
      {
        title: "Local Transport",
        image: "/3-3.jpeg",
      },
      {
        title: "Transport Tracking",
        image: "/4-4.webp",
      },
    ],
    images: ["/road-transport-01.jpg", "/1-1.jpg", "/2-2.jpg"],

    headings: {
      main: "Efficient Road Transport Solutions",
      glance: "At a Glance",
    },

    glanceItems: [
      "Daily Groupage Services – Quick and cost-effective LTL shipments across key routes",
      "Full Truckload (FTL) Delivery – Reliable door-to-door transport for bulk cargo",
      "Advanced Tracking & IT Systems – Real-time GPS updates and seamless digital connectivity (EDI)",
      "Expert Logistics Team – Experienced professionals ensuring smooth and efficient deliveries",
    ],

    contentParagraphs: [
      "Whether you need full truckloads (FTL) or smaller group shipments (LTL), our road transport services are designed to meet your needs. With the latest technology and a skilled team, we ensure your shipments are delivered on time, safely, and at a competitive cost. Enjoy reliable capacities, quick transit times, and a variety of transport options to suit your business.",
      "Every day, our fleet of vehicles works hard to deliver your goods efficiently across Pakistan and beyond. As part of well-established logistics networks, we ensure your shipments reach their destination securely. Plus, with our experienced team, we offer the peace of mind you need for smooth and successful transport operations.",
    ],
  },

  "custom-clearance": {
    title: "Custom Clearance",
    description: "Hassle-free and efficient customs processing.",
    buttons: [
      "Let's Do Business",
      "Regulatory Compliance",
      "Tax & Duty Management",
      "Fast Processing",
    ],
    products: [
      {
        title: "Cargo Customs Clearance",
        image: "/customs-cargo-1.jpg", // Replace with actual URL
      },
      {
        title: "Air Cargo Customs Clearance",
        image: "/customs-2.jpeg",
      },
      {
        title: "Export Invoice",
        image: "/10-1.jpg",
      },
    ],
    images: ["/custom-1.jpg", "/custom-2.jpg", "/custom-3.jpg"],

    headings: {
      main: "Efficient Customs Clearance Services",
      glance: "At a Glance",
    },

    glanceItems: [
      "Expert Customs Handling – Smooth and reliable customs clearance for all types of shipments",
      "Compliance with Regulations – Ensuring your shipments meet all local and international regulations",
      "Fast & Secure Process – Streamlined procedures for quicker and hassle-free delivery",
      "Documentation Support – Complete assistance with all necessary paperwork and duties for a seamless experience",
    ],

    contentParagraphs: [
      "Whether you’re shipping full truckloads (FTL) or smaller shipments (LTL), we offer fast and reliable customs clearance solutions tailored to your needs. Our experienced team handles all paperwork, ensuring your shipments meet local and international regulations. From calculating duties and taxes to ensuring smooth compliance, we simplify the customs process for faster deliveries.",
      "Each day, our team works to clear your shipments quickly, minimizing delays and costs. With access to a wide network of trusted partners, we ensure your goods pass through customs smoothly, providing the security and expertise you need for a successful and efficient operation.",
    ],
  },
};

const ServicePage = () => {
  const { service } = useParams();
  const serviceInfo = serviceData[service];

  if (!serviceInfo) {
    return <h2>Service Not Found</h2>;
  }

  // Slider Settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <>
      <Header />
      <div className="service-page">
        <div className="breadcrumb">
          <a href="/">Home</a> &gt; <a href="/products">Products</a> &gt;{" "}
          {serviceInfo.title}
        </div>

        <h1>{serviceInfo.title}</h1>
        <p>{serviceInfo.description}</p>

        <div className="buttons-container">
          {serviceInfo.buttons.map((btnText, index) => (
            <button
              key={index}
              className={index === 0 ? "btn btn-primary" : "btn btn-secondary"}
            >
              {btnText}
            </button>
          ))}
        </div>

        {/* Image Slider */}
        <div className="service-slider">
          <Slider {...sliderSettings}>
            {serviceInfo.images.map((imgSrc, index) => (
              <div key={index}>
                <img
                  src={imgSrc}
                  alt={`Slide ${index + 1}`}
                  className="slider-image"
                />
              </div>
            ))}
          </Slider>
        </div>

        {serviceInfo.headings?.main && (
          <div className="roadfreight-container">
            <div className="content">
              <h2>{serviceInfo.headings.main}</h2>
              {serviceInfo.contentParagraphs?.map((para, index) => (
                <p key={index}>{para}</p>
              ))}
              <button className="business-btn">LET'S DO BUSINESS</button>
            </div>
            <div className="sidebar">
              {serviceInfo.headings?.office && (
                <h3>{serviceInfo.headings.office}</h3>
              )}
              {serviceInfo.headings?.glance && (
                <h3>{serviceInfo.headings.glance}</h3>
              )}
              <ul>
                {serviceInfo.glanceItems?.map((item, index) => (
                  <li key={index}>➡️ {item}</li>
                ))}
              </ul>
              {/* <button className="cyber-security-btn">CYBER SECURITY</button> */}
            </div>
          </div>
        )}

        {/* Products Section (Only for Air Freight) */}

        {serviceInfo.products && (
          <div className="service-products">
            <h2>Our {serviceInfo.title} Products</h2>
            <div className="products">
              {serviceInfo.products.map((product, index) => (
                <div key={index} className="product-card">
                  <img src={product.image} alt={product.title} />
                  <div className="overlay">
                    <h3>{product.title}</h3>
                    <div className="arrow">{">>"}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="service-section-5">
          <h2>
            The Solution of any <br></br> problem at your fingertips
          </h2>
          <div className="section-5-options">
            <div className="service-section-5-catagories">
              <img src={img1} alt="" />
              <p>Over 140+ Categories</p>
            </div>
            <div className="service-section-5-catagories">
              <img src={img1} alt="" />
              <p>Over 140+ shipment per week</p>
            </div>
          </div>
        </div>
        <footer>
          <div className="background">
            <img src={worldImage} alt="world" />
            <div className="footer-content">
              <ul className="footer-content__list">
                <li>Home</li>
                <li>Services</li>
                <li>Blog</li>
                <li>About Us</li>
                <li>Contact Us</li>
                <li>Privacy Policy</li>
              </ul>
              <div className="footer-content__social">
                <p>WHISTLEBLOWING</p>
                <p>LEGAL</p>
                <p>PRIVACY</p>
                <p>COOKIES</p>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ServicePage;
